import { useLanguage } from '@/components/utils/useLanguage';
import CarouselWithHeader, { CarouselItem } from '@/components/ui/CarouselWithHeader';
import SliderCard, { ageImages } from '@/components/home/SliderCard';
import { filtersToParams } from '@/utils/filterUrlParams';
import { container, sectionPadding, sectionBgWhite } from '@/lib/ds';

export default function AgeGroupsSection({ activities = [] }) {
  const { t } = useLanguage();

  const ageGroups = [
    { value: '1-3',   label: t('Kleinkinder', 'Toddlers'),        age: t('1–3 Jahre', '1–3 Years') },
    { value: '4-6',   label: t('Kindsgi-Kinder', 'Kindergarten'), age: t('4–6 Jahre', '4–6 Years') },
    { value: '7-11',  label: t('Schulkinder', 'School kids'),     age: t('7–11 Jahre', '7–11 Years') },
    { value: '12-16', label: t('Teenager', 'Teenagers'),          age: t('12–16+ Jahre', '12–16+ Years') },
  ];

  return (
    <section className={`${sectionPadding} ${sectionBgWhite}`}>
      <div className={container}>
        <CarouselWithHeader
          title={t('Ausflugsideen nach Alter', 'Ideas by Age Group')}
          subtitle={t('Finde altersgerechte Ausflüge mit Kindern: vom Kleinkind bis Teenager', 'Find age-appropriate outings for children: from toddlers to teenagers')}
          overflowY
        >
          {ageGroups.map((group) => {
            const [ageMin, ageMax] = group.value.split('-').map(Number);
            const count = activities.filter(a =>
              (a.age_min ?? 0) <= ageMax && (a.age_max ?? 16) >= ageMin
            ).length;
            return (
              <CarouselItem key={group.value} className="pl-4 basis-[193px] md:basis-1/4 lg:basis-1/4">
                <SliderCard
                  to={`/ausflugsideen?${filtersToParams({ alter: [group.value] }).toString()}`}
                  title={group.label}
                  subtitle={group.age}
                  image={ageImages[group.value]}
                  count={count}
                  countLabel={t('Ausflüge', 'Trips')}
                />
              </CarouselItem>
            );
          })}
        </CarouselWithHeader>
      </div>
    </section>
  );
}